module.exports = __webpack_public_path__ + "img/submit-success.a98ce04c.png";